import React from "react";
import { maintenance, qhseBg } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Maintenance & Repair" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("Maintenance & Repair")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "We offer regular and emergency maintenance services to keep your equipment operating at peak performance. Our team handles troubleshooting, diagnostics, part replacements, and complete overhauls — minimizing downtime and extending the lifespan of your assets."
              )}
            </p>

            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("Why Choose Us?")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>
                {t("Experienced technicians ensuring high-quality repairs")}
              </li>
              <li>{t("Rapid response to minimize operational downtime")}</li>
              <li>
                {t("Use of certified parts and industry-approved methods")}
              </li>
              <li>
                {t("Comprehensive maintenance plans tailored to your needs")}
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 grid grid-cols-1 gap-4 mt-8 md:mt-0">
            <img
              src={maintenance}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Maintenance;
